import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Intake() {
  const [form, setForm] = useState({ name: "", bio: "" });
  const [saving, setSaving] = useState(false);
  const { user, setUser } = useAuth();
  const navigate = useNavigate();

  const submit = async () => {
    if (!form.name.trim()) {
      toast.error("What should your people call you?");
      return;
    }
    setSaving(true);
    try {
      const res = await api.put("/profile/intake", form);
      setUser(res.data);
      toast.success("Welcome to Bouquet");
      navigate("/");
    } catch {
      toast.error("Could not save");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-background px-4 sm:px-8 py-10" data-testid="intake-page">
      <div className="max-w-md mx-auto space-y-8">
        <div className="space-y-3 text-center">
          <img src="/logo-trim.png" alt="Bouquet" className="h-16 w-36 object-contain rounded-lg mx-auto" />
          <h1 className="font-display text-3xl sm:text-4xl font-medium tracking-tight">Welcome in</h1>
          <p className="text-sm text-muted-foreground">Just the essentials. Everything else can wait.</p>
        </div>

        <div className="bg-card border border-border rounded-xl p-6 sm:p-8 space-y-5">
          <div>
            <label className="text-sm font-semibold block mb-1.5">Your name</label>
            <input data-testid="intake-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder={user?.name || "Your name"}
              className="w-full px-3.5 py-2.5 rounded-lg border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-ring" />
          </div>
          <div>
            <label className="text-sm font-semibold block mb-1.5">A little about you <span className="font-normal text-muted-foreground">(optional)</span></label>
            <textarea data-testid="intake-bio-input" value={form.bio} onChange={(e) => setForm({ ...form, bio: e.target.value })}
              rows={3} placeholder="Whatever feels true right now…"
              className="w-full px-3.5 py-2.5 rounded-lg border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-ring" />
          </div>
          <button data-testid="intake-submit-button" onClick={submit} disabled={saving}
            className="w-full bg-primary text-primary-foreground py-3 rounded-full text-sm font-semibold hover:opacity-90 transition-opacity disabled:opacity-50">
            {saving ? "Saving…" : "Step into your Bouquet"}
          </button>
        </div>
      </div>
    </div>
  );
}
